<template>
    <router-link :to="{ name: 'invitation.show', params: { id: invitation.id } }" tag="div" class="group shadow mb-6 text-grey-darkest leading-normal rounded">
        <div class="flex items-top p-3 md:p-6 bg-white rounded-t cursor-pointer">
            <avatar :avatar="invitation.doctorAvatar" :name="invitation.doctorFirstName + ' ' + invitation.doctorLastName" class="mr-2 w-10 h-10 md:w-12 md:h-12"></avatar>
            <div class="ml-4">
                <div class="flex md:mb-1">
                    <span class="icon mr-2 md:text-lg text-grey-darkest"><i class="mdi mdi-calendar-check"></i></span>
                    <span class="text-grey-darkest font-semibold text-sm md:text-base">{{ invitation.date | momentFormat('YYYY-MM-DD', $t('date_selector_format')) }} {{ $t('at') }} {{ invitation.time | momentFormatTime($t('time_format')) }}</span>
                </div>
                <div class="flex md:mb-1">
                    <span class="icon mr-2 text-lg text-red-light"><i class="mdi mdi-map-marker"></i></span>
                    <span class="text-sm md:text-base">
                        {{ invitation.officeZipCode }} {{ invitation.officeLocality }}
                    </span>
                </div>
                <div class="flex md:mb-1">
                    <span class="icon mr-2 text-lg text-blue-light"><i class="mdi mdi-account"></i></span>
                    <span class="text-sm md:text-base">{{ invitation.doctorFirstName + ' ' + invitation.doctorLastName }}</span>
                </div>
                <div class="flex">
                    <span class="icon mr-2 text-sm text-grey"><i class="mdi mdi-briefcase"></i></span>
                    <span class="text-sm">{{ $t('type_' + invitation.emergencyType) }} <span class="mdi mdi-check-circle text-green" v-if="invitation.isDoctorMemberOfOsteopathie"></span></span>
                </div>
            </div>
        </div>
        <div class="flex rounded-b py-3 px-2 justify-end items-center">
            <router-link :to="{ name: 'invitation.show', params: { id: invitation.id, decline: true } }" class="text-blue hover:text-blue-dark uppercase tracking-wide font-semibold text-sm px-2">{{ $t('Decline') }}</router-link>
            <router-link :to="{ name: 'invitation.show', params: { id: invitation.id } }" class="text-blue hover:text-blue-dark uppercase tracking-wide font-semibold text-sm px-2">{{ $t('Accept') }}</router-link>
        </div>
    </router-link>
</template>
<script>
    export default {
        name: 'invitation-list-item',

        props: ['invitation']
    }
</script>



// WEBPACK FOOTER //
// src/components/Patient/InvitationListItem.vue